import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { Menu, SubMenu } from '@models/menu.model';
import { GraphQlQuery } from '@models/query.model';
import { BehaviorSubject, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private http = inject(HttpClient);
  #menu = new BehaviorSubject<Menu[]>([]);
  #subMenu = new BehaviorSubject<SubMenu>({ path: '', icon: '', name: '', code: '', roles: []});
  #menu$ = this.#menu.asObservable();
  currentPage$ = this.#subMenu.asObservable();

  getMenuBySeller(sellerId: string, id: string){
    const query : GraphQlQuery = {
      query: `query GetUserMenu($seller: ObjectID!) {
        Menu(seller: $seller) {
          name
          path
          icon
          code
          sub_menus {
              name
              path
              icon
              code
              roles {
                rw
                internal
                code
              }
          }
        }
      }`,
      variables: {
        seller: sellerId
      }
    };
    return this.http.post<{data:{ Menu: Menu[]}}>(environment.mainApiUri, query)
      .pipe(map(response => {
        if(id && id.length > 0){
          const key = `${environment.country}:${id}:${btoa(sellerId)}:menu`;
          if(window.localStorage.getItem(key) === null){ 
            window.localStorage.setItem(key, btoa(JSON.stringify(response.data.Menu))); 
          }
        }
        return response.data.Menu;
      }));
  }

  getAdminMenu(id: string){
    const query : GraphQlQuery = {
      query: `query GetUserMenu {
        Menu {
          name
          path 
          icon
          position
          sub_menus {
              position
              name
              path
              icon
              code
              roles {
                  code
                  rw
                  internal
              }
          }
        }
      }`
    };
    return this.http.post<{data:{ Menu: Menu[]}}>(environment.adminApiUri, query)
      .pipe(map(response => {
        if(id && id.length > 0){
          const key = `${environment.country}:${id}:adm:menu`;
          if(window.localStorage.getItem(key) === null){ 
            window.localStorage.setItem(key, btoa(JSON.stringify(response.data.Menu))); 
          }
        }
        return response.data.Menu;
      }));
  }

  setCurrentPage(page: SubMenu){
    this.#subMenu.next(page);
  }

  setCurrentPageViaURL(url: string){
    const parts = url.split('/').filter(Boolean);
    const parent = `/${parts[0]}`;
    const child = `/${parts[1]}`;

    this.#menu$.subscribe(menu => {
      const parentMenu = menu.filter(m => m.path === parent)[0];
      if(parentMenu){
        const childSubmenu = parentMenu.sub_menus.filter(s => s.path === child)[0]
        if(childSubmenu) this.#subMenu.next(childSubmenu);
      }
    })
  }

  getMenu$() {
    return this.#menu$;
  }

  getMenu(admin: boolean, seller: string, id: string) {
    if (admin)
      this.getAdminMenu(id).subscribe((menu) => this.#menu.next(menu));
    else this.getMenuBySeller(seller, id).subscribe((menu) => this.#menu.next(menu));
  }
}


